import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
// import Modal from '@mui/material/Modal';
import { Modal } from 'react-bootstrap';
import LoadingButton from '@mui/lab/LoadingButton';
import Header from '../BaseComponents/Header'
import FotterMain from '../BaseComponents/FotterMain'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { getCommonAPIData, jobApply } from '../../networkCalls';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { getJobsList } from '../../networkCalls';
import FullPageApiLoadingCell from '../BaseComponents/FullPageApiLoadingCell';
import JobsViewCell from './JobsViewCell';
import CloseIcon from '@mui/icons-material/Close';
import { actionTypes, useStateValue } from '../../store';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL } from '../../networkCalls';
import SEO from '../BaseComponents/SEO';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll',
};

const expddl = [
  {
    value: '0',
    label: '0 years',
  },
  {
    value: '1',
    label: '1 years',
  },
  {
    value: '2',
    label: '2 years',
  },
  {
    value: '3',
    label: '3 years',
  },
  {
    value: '4',
    label: '4 years',
  },
  {
    value: '5',
    label: '5 years',
  },
  {
    value: '6',
    label: '6 years',
  },
  {
    value: '7',
    label: '7 years',
  },
  {
    value: '8',
    label: '8 years',
  },
  {
    value: '9',
    label: '9 years',
  },

  {
    value: '10',
    label: '10 years',
  },
  {
    value: '11',
    label: '11 years',
  },
  {
    value: '12',
    label: '12 years',
  },
  {
    value: '13',
    label: '13 years',
  },
  {
    value: '14',
    label: '14 years',
  },
  {
    value: '15',
    label: '15 years',
  },
  {
    value: '16',
    label: '16 years',
  },
  {
    value: '16',
    label: '16 years',
  },
  {
    value: '17',
    label: '17 years',
  },
  {
    value: '18',
    label: '18 years',
  },
  {
    value: '19',
    label: '19 years',
  },
  {
    value: '20',
    label: '20 years',
  },
  {
    value: '21',
    label: '21 years',
  },
  {
    value: '22',
    label: '22 years',
  },
  {
    value: '23',
    label: '23 years',
  },
  {
    value: '24',
    label: '24 years',
  },
  {
    value: '25',
    label: '25 years',
  },
  {
    value: '26',
    label: '26 years',
  },
  {
    value: '27',
    label: '27 years',
  },
  {
    value: '28',
    label: '28 years',
  },
  {
    value: '29',
    label: '29 years',
  },
  {
    value: '30',
    label: '30 years',
  },
  {
    value: '31',
    label: '31 years',
  },
  {
    value: '32',
    label: '32 years',
  },
  {
    value: '33',
    label: '33 years',
  },
  {
    value: '34',
    label: '34 years',
  },
  {
    value: '35',
    label: '35+ years',
  },
];
const ageddl = [
  {
    value: '18',
    label: '18 years',
  },
  {
    value: '19',
    label: '19 years',
  },
  {
    value: '20',
    label: '20 years',
  },
  {
    value: '21',
    label: '21 years',
  },
  {
    value: '22',
    label: '22 years',
  },
  {
    value: '23',
    label: '23 years',
  },
  {
    value: '24',
    label: '24 years',
  },
  {
    value: '25',
    label: '25 years',
  },
  {
    value: '26',
    label: '26 years',
  },
  {
    value: '27',
    label: '27 years',
  },
  {
    value: '28',
    label: '28 years',
  },
  {
    value: '29',
    label: '29 years',
  },
  {
    value: '30',
    label: '30 years',
  },
  {
    value: '31',
    label: '31 years',
  },
  {
    value: '32',
    label: '32 years',
  },
  {
    value: '33',
    label: '33 years',
  },
  {
    value: '34',
    label: '34 years',
  },
  {
    value: '35',
    label: '35 Years',
  },
  {
    value: '36',
    label: '36 Years',
  },
  {
    value: '37',
    label: '37 Years',
  },
  {
    value: '38',
    label: '38 Years',
  },
  {
    value: '39',
    label: '39 Years',
  },
  {
    value: '40',
    label: '40 Years',
  },
  {
    value: '41',
    label: '41 Years',
  },
  {
    value: '42',
    label: '42 Years',
  },
  {
    value: '43',
    label: '43 Years',
  },
  {
    value: '44',
    label: '44 Years',
  },
  {
    value: '45',
    label: '45 Years',
  },
  {
    value: '46',
    label: '46 Years',
  },
  {
    value: '47',
    label: '47 Years',
  },
  {
    value: '48',
    label: '48 Years',
  },
  {
    value: '49',
    label: '49 Years',
  },
  {
    value: '50',
    label: '50 Years',
  },
  {
    value: '51',
    label: '51 Years',
  },
  {
    value: '52',
    label: '52 Years',
  },
  {
    value: '53',
    label: '53 Years',
  },
  {
    value: '54',
    label: '54 Years',
  },
  {
    value: '55',
    label: '55 Years',
  },
  {
    value: '56',
    label: '56 Years',
  },
  {
    value: '57',
    label: '57 Years',
  },
  {
    value: '58',
    label: '58 Years',
  },
  {
    value: '59',
    label: '59 Years',
  },
  {
    value: '60',
    label: '60 Years',
  },

];
const genderddl = [
  {
    value: 'male',
    label: 'Male',
  },
  {
    value: 'female',
    label: 'Female',
  },
  {
    value: 'others',
    label: 'Others',
  },
];
const mstatusddl = [
  {
    value: 'single',
    label: 'Single',
  },
  {
    value: 'married',
    label: 'Married',
  },
  {
    value: 'divorced',
    label: 'Divorced',
  },
  {
    value: 'others',
    label: 'Others',
  },
];
const abledddl = [
  {
    value: 'yes',
    label: 'Yes',
  },
  {
    value: 'no',
    label: 'No',
  },
];

const promise = getCommonAPIData();
const CareersLP = () => {
  const [{ token, huid, }, dispatch] = useStateValue();
  const validationSchema = yup.object({
    name: yup
      .string('Enter your name')
      .required('Name is required'),
    totalexp: yup
      .string('Select Total Experience')
      .required('Total experience is required'),
    age: yup
      .string('Select Age')
      .required('Age is required'),
    gender: yup
      .string('Select Gender')
      .required('Gender is required'),
    hiquli: yup
      .string('Select qulification')
      .required('Highest educational is required'),
    ccompany: yup
      .string('Select Company')
      .required('Current company is required'),
    cdesignation: yup
      .string('Select Designation')
      .required('Current designation is required'),
    clocation: yup
      .string('Select Location')
      .required('Current location is required'),
    ctc: yup
      .string('Select CTC')
      .required('Current CTC is required'),
    ectc: yup
      .string('Select CTC')
      .notRequired(''),
    mstatus: yup
      .string('Select Marital Status')
      .required('Marital status is required'),
    abled: yup
      .string('Select Differently Abled')
      .notRequired(''),
    mobile: yup
      .string('')
      .required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, 'Enter 10 digit mobile number')
      .max(10, 'Enter 10 digit mobile number'),
    email: yup
      .string('Enter your email')
      .required('Email is required')
      .email('Enter a valid email id'),
  });

  const toTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    toTop();
  }, []);

  const [loading, setLoading] = useState(false);
  const [errMessage, setErrMessage] = useState('');
  const [jobs, setJobs] = React.useState('');
  const checkjobListData = () => {
    var data = new FormData();
    // data.append('customerId', huid);
    // data.append('XAuth', token);
    setLoading(true);
    getJobsList(data).then((res) => {
      setLoading(false);
      switch (res.data.status) {
        case 1:
          setJobs(res?.data?.jobsList)
          setErrMessage('');
          return true;
        case 0:
          setErrMessage(res.data.msz);
          break;
        default:
          return;
      }
    })
  }



  const [departmentddl, setDepartmentddl] = useState(null);
  useEffect(() => {
    promise.then(data => {
      setDepartmentddl(data?.departmentList)
    });
  }, []);


  const [susMessage, setSusMessage] = useState('');
  const [openJob, setOpenJob] = useState(false);
  const handleOpenJob = () => setOpenJob(true);
  const handleCloseJob = () => setOpenJob(false);

  const [openpop, setOpenpop] = useState(false);
  const handleClosepop = () => setOpenpop(false);


  useEffect(() => {
    checkjobListData();
    setOpenpop(true)

  }, []);

  const [file, setFileState] = React.useState(null);
  const userAttachment = e => {
    if (validateFileSize(e)) {
      setFileState(e.target.files[0]);
    }
  };
  const [err, seterr] = React.useState("");
  const validateFileSize = (e) => {
    let file = e.target.files[0];
    let size = 2000000;
    if (file.size > size) {
      setErrMessage('File To large');
      return false
    }
    setErrMessage('');
    return true
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      totalexp: '',
      age: '',
      gender: '',
      hiquli: '',
      ccompany: '',
      cdesignation: '',
      clocation: '',
      ctc: '',
      ectc: '',
      mstatus: '',
      abled: '',
      mobile: '',
      email: '',
      department: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      var data = new FormData();
      data.append('name', values.name);
      data.append('email', values.email);
      data.append('mobile', values.mobile);
      data.append('currentJobLocation', values.clocation);
      data.append('experience', values.totalexp);
      data.append('age', values.age);
      data.append('gender', values.gender);
      data.append('heighestEducationQualification', values.hiquli);
      data.append('currentCompany', values.ccompany);
      data.append('currentDesignation', values.cdesignation);
      data.append('currentCtc', values.ctc);
      data.append('expectedCtc', values.ectc);
      data.append('maritialStatus', values.mstatus);
      data.append('differentlyAbled', values.abled);
      data.append('uploadCv', file);
      data.append('jobId', '');
      data.append('department', values.department);
      setLoading(true);
      setErrMessage('');
      setSusMessage('');
      jobApply(data).then((res) => {
        setLoading(false);
        switch (res.data.status) {
          case 1:
            setOpenJob(false)
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            return true;
          case 0:
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            setErrMessage(res.data.msz);
            break;
          default:
            return;
        }
      });
    },
  });


  const enabledbtn = file && formik.values.name && formik.values.totalexp && formik.values.age && formik.values.gender && formik.values.hiquli && formik.values.ccompany && formik.values.cdesignation
    && formik.values.clocation && formik.values.ctc && formik.values.mstatus && formik.values.mobile && formik.values.email && formik.values.department;

  return (
    <>
     <SEO
            title="Honda India Power Products | Honda Careers"
            description="Boost your career wit Honda jobs, India's leading power product company. Apply for job vacancies and get on board"
            name="HIPP - Honda India Power"
            url="https://www.hondaindiapower.com/careers"
            type='Website' />
      <Header />
      <div className="post-view__header post-header post-header--has-image" style={{display: 'block'}}>
        <div className="post-header__image post-header__image-car " style={{textAlign: 'center'}}>
          <LazyLoadImage
            alt=""
            effect="blur"
            className='img-fluid'
            src={`${baseURL}images/business-people-teamwork.jpg`}
          />
        </div>
      </div>
      <div className='innerpagebg pt-5 pb-5' style={{ zIndex: '1', position: 'relative' }}>
        <div className='container pt-1 pb-5' style={{textAlign: 'justify'}}>
          <div className='row'>
            <div className='col-12'>
              <h4 className='d-block mb-3 fw-bold text-uppercase mb-0 mt-2  f20'>
                <span className='txtred'>CAREER</span> <span className='txtdgray'>INFORMATION</span>
              </h4>
              <p className='f16' style={{ lineHeight: '24px' }}>We appreciate your interest in exploring career opportunities with us. At Honda we provide you with growth opportunities at every step of your career. We believe in providing a multi-faceted exposure across domains and roles that are equipped with a flexibility that allows you to discover your ideal role, and thus helping you achieve your true potential.</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <h4 className='d-block mb-3 fw-bold text-uppercase mb-0 mt-2  f20'>
                <span className='txtred'>JOIN OUR</span> <span className='txtdgray'>FAMILY</span>
              </h4>
              <p className='f16' style={{ lineHeight: '24px' }}>
                Today’s business scenario is extremely dynamic in terms of technological advancements, customer expectations and environmental regulations which demands steady propulsion in the approach. Successful implementation of any business strategy thrives around the involvement of human capital in the organization's innovation and growth expedition blended with technology. HIPP is committed to taking on the challenges and making it an agile and a self-reliant organization and the best place to work.
              </p>
              <p className='f16' style={{ lineHeight: '24px' }}>Believe in the power of dreams!</p>
              <p className='f16' style={{ lineHeight: '24px' }}>Join us and be part of the journey in creating the "company society wants to exist" and be the cause of “joy of expanding life’s potential of people worldwide”. Honda’s greatest asset is its people. We believe in “Empower People, To Do better”. <span className=''>We welcome your association with us.</span></p>
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <h4 className='d-block mb-3 fw-bold text-uppercase mb-0 mt-2  f20'>
                <span className='txtred'>WHAT ARE </span> <span className='txtdgray'>WE LOOKING FOR</span>
              </h4>
              <p className='f16' style={{ lineHeight: '24px' }}>
                At HIPP, we maintain high standards of excellence by identifying, hiring, and retaining the “Right People”. Who are the “Right People”? They are challenge-seekers following their dreams with the creativity and drive to perform at the highest level. Committed and enthusiastic team players. Constant innovators who put customers first. Keen thinkers who are armed with both professionalism and a desire to take an active role on the global stage. And the people with integrity who value the Honda way!
              </p>
              <p className='f18 fw-bold' style={{ lineHeight: '24px' }}>How To Apply</p>
              <p className='f16' style={{ lineHeight: '24px' }}>Applicants should consult our Current openings and follow the instructions to submit their application. Once received, we will review all the applications to determine the profiles ideal for the defined role and will be connected for the interview process depending upon the role.</p>
              <p className='f16' style={{ lineHeight: '24px' }}>Please refer the <span className='fw-bold text-uppercase text-danger'>Current</span> <span className='fw-bold  text-uppercase'>Openings</span> below and submit your CV for our consideration.</p>
            </div>
          </div>
        </div>
        <div className='container mb-4'>
          <div className='row'>
            <div className='col-12 col-lg-12  m-auto'>
              <div className="align-items-center text-left">
                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                  <span className='txtred'>current </span> <span className='txtdgray'>openings</span>
                </h4>
              </div>
            </div>
            {/* <div className='col-12 col-lg-6'>
              <div className="align-items-center text-end">
                <Button
                  variant="contained"
                  onClick={handleOpenJob}
                  color='error'
                  size="small" className='ms-3 mt-2'>
                  Submit Your Resume
                </Button>
              </div>
            </div> */}
          </div>
        </div>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              {errMessage ? <><Alert severity="error">{errMessage}</Alert></> : null}
              {loading ? <><FullPageApiLoadingCell /></> : <>
                <div className='row'>
                  {jobs && jobs?.length > 0 && jobs?.map((data, i) => (
                    <JobsViewCell itemIn={data} key={i} />
                  ))}
                  {jobs && jobs.length <= 0 ? <><div className='row'>
                    <div className='col-lg-12'>
                      <div className='card text-center p-4 f18 text-danger'>
                        CURRENTLY THERE IS NO OPENING
                      </div>
                    </div>
                  </div></> : <>
                  </>}
                </div>
              </>}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={openJob}
        // onClose={handleCloseProfile}
        aria-labelledby=""
        aria-describedby=""
      >
        <Box sx={{ ...style, width: { xs: 300, sm: 700 }, height: { xs: '100%', sm: 'auto' }, }}>
          <IconButton
            onClick={handleCloseJob}
            size="medium"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ float: 'right', position: 'absolute', right: '20px', top: '20px', zIndex: '3' }}
          >
            <CancelIcon />
          </IconButton>
          <div>
            <div className='row'>
              <div className='col-12 mb-3'>
                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                  <span className='txtred'>SUBMIT</span> <span className='txtdgray'>RESUME</span>
                </h4>
              </div>
            </div>
            {errMessage ? <><Alert severity="error">{errMessage}</Alert></> : null}
            {susMessage ? <><Alert severity="success">{susMessage}</Alert></> : null}
            <form onSubmit={formik.handleSubmit} autoComplete="off">
              <div className='row mt-3'>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    id="department"
                    className='mb-3 w-100'
                    select
                    label="Department"
                    name="department"
                    variant="standard"
                    value={formik.values.department}
                    onChange={formik.handleChange}
                    error={formik.touched.department && Boolean(formik.errors.department)}
                    helperText={formik.touched.department && formik.errors.department}
                  >
                    {departmentddl?.map((option, i) => (
                      <MenuItem key={i} value={option.department}>
                        {option.department}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="name"
                    name="name"
                    label="Your Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    id="totalexp"
                    className='mb-3 w-100'
                    select
                    label="Total Experience"
                    name="totalexp"
                    variant="standard"
                    value={formik.values.totalexp}
                    onChange={formik.handleChange}
                    error={formik.touched.totalexp && Boolean(formik.errors.totalexp)}
                    helperText={formik.touched.totalexp && formik.errors.totalexp}
                  >
                    {expddl?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    id="age"
                    className='mb-3 w-100'
                    select
                    label="Age"
                    name="age"
                    variant="standard"
                    value={formik.values.age}
                    onChange={formik.handleChange}
                    error={formik.touched.age && Boolean(formik.errors.age)}
                    helperText={formik.touched.age && formik.errors.age}
                  >
                    {ageddl?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    id="gender"
                    className='mb-3 w-100'
                    select
                    label="Gender"
                    name="gender"
                    variant="standard"
                    value={formik.values.gender}
                    onChange={formik.handleChange}
                    error={formik.touched.gender && Boolean(formik.errors.gender)}
                    helperText={formik.touched.gender && formik.errors.gender}
                  >
                    {genderddl?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="hiquli"
                    name="hiquli"
                    label="Highest Educational Qualification"
                    value={formik.values.hiquli}
                    onChange={formik.handleChange}
                    error={formik.touched.hiquli && Boolean(formik.errors.hiquli)}
                    helperText={formik.touched.hiquli && formik.errors.hiquli}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="ccompany"
                    name="ccompany"
                    label="Current Company"
                    value={formik.values.ccompany}
                    onChange={formik.handleChange}
                    error={formik.touched.ccompany && Boolean(formik.errors.ccompany)}
                    helperText={formik.touched.ccompany && formik.errors.ccompany}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="cdesignation"
                    name="cdesignation"
                    label="Current Designation"
                    value={formik.values.cdesignation}
                    onChange={formik.handleChange}
                    error={formik.touched.cdesignation && Boolean(formik.errors.cdesignation)}
                    helperText={formik.touched.cdesignation && formik.errors.cdesignation}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="clocation"
                    name="clocation"
                    label="Current Location"
                    value={formik.values.clocation}
                    onChange={formik.handleChange}
                    error={formik.touched.clocation && Boolean(formik.errors.clocation)}
                    helperText={formik.touched.clocation && formik.errors.clocation}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="ctc"
                    name="ctc"
                    label="Current CTC"
                    value={formik.values.ctc}
                    onChange={formik.handleChange}
                    error={formik.touched.ctc && Boolean(formik.errors.ctc)}
                    helperText={formik.touched.ctc && formik.errors.ctc}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    className='mb-3 w-100'
                    variant="standard"
                    id="ectc"
                    name="ectc"
                    label="Expected CTC"
                    value={formik.values.ectc}
                    onChange={formik.handleChange}
                    error={formik.touched.ectc && Boolean(formik.errors.ectc)}
                    helperText={formik.touched.ectc && formik.errors.ectc}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    id="mstatus"
                    className='mb-3 w-100'
                    select
                    label="Marital Status"
                    name="mstatus"
                    variant="standard"
                    value={formik.values.mstatus}
                    onChange={formik.handleChange}
                    error={formik.touched.mstatus && Boolean(formik.errors.mstatus)}
                    helperText={formik.touched.mstatus && formik.errors.mstatus}
                  >
                    {mstatusddl?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    id="abled"
                    className='mb-3 w-100'
                    select
                    label="Differently Abled"
                    name="abled"
                    variant="standard"
                    value={formik.values.abled}
                    onChange={formik.handleChange}
                    error={formik.touched.abled && Boolean(formik.errors.abled)}
                    helperText={formik.touched.abled && formik.errors.abled}
                  >
                    {abledddl?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    variant="standard"
                    className='mb-3 w-100'
                    label="Mobile Number"
                    inputProps={{
                      maxLength: 10
                    }}
                    id="mobile"
                    name="mobile"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                    helperText={formik.touched.mobile && formik.errors.mobile}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <TextField
                    required
                    className='mb-3 w-100'
                    variant="standard"
                    id="email"
                    name="email"
                    label="Email ID"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <div>Upload CV * - <span className='f12'>(max size: 2MB)</span></div>
                  <input
                    accept=".docx,.doc,image/jpeg,image/png,application/pdf"
                    type="file"
                    onChange={userAttachment}
                    className="mb-3 w-100 mt-2"
                    defaultValue=""
                  />
                </div>
                <div className='col-12 col-lg-12 mt-2'>
                  {!loading ? <Button color="error" disabled={!enabledbtn} variant="contained" className='w-100' type="submit">
                    SUBMIT
                  </Button> : <LoadingButton className="w-100"
                    loading
                    loadingPosition="end"
                    variant="contained"
                  >
                    SUBMIT...
                  </LoadingButton>}
                </div>
              </div>
            </form>
          </div>
        </Box>
      </Modal>
      <Modal
        size="lg"
        show={openpop}
        backdrop="static"
        keyboard={false}
        centered
        contentClassName='border-0 rounded-0'
        onHide={() => handleClosepop()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div onClick={() => handleClosepop()} aria-label="delete" size="small" className="position-absolute top-0 end-0 btn-out">
            <CloseIcon fontSize="small" className='text-white' />
          </div>
          <div className='p-4'>
            <div className='row'>
              <div className='col-12'>
                <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                  <span className='txtred'>User</span> <span className='txtdgray'>Information</span>
                </h4>
              </div>
              <div className='col-12'>
                <div className="mt-3 f16" style={{ 'lineHeight': '24px', textAlign:'justify' }}>
                  <p>Honda is aware of fake emails, popularly called "phishing" emails regarding job advertisements, job
                    offers and competition award notifications. These emails use Honda's name to pretend they are genuine
                    and exist solely for the purpose of obtaining private information about consumers (e.g., credit card
                    numbers or passwords). These emails have no connection with Honda and Honda does not use these
                    methods for job advertising or competition / award winner activity.</p>
                  <p>Unfortunately, these fake emails are a growing fraud on the Internet. This practice is carried out either
                    by the sending of a bogus email directly to a victim, or by directing them to a website where personal
                    information is requested. Honda advises that if you receive an email using Honda's name and asking for
                    personal information or financial information and have concerns about its authenticity, then please
                    treat such emails with extreme caution and do not reveal your personal &amp; financial details.</p>
                </div>
              </div>
            </div>
          </div>

        </Modal.Body>
      </Modal>
      <div style={{ clear: 'both', height: '40px' }}></div>
      <FotterMain />
    </>
  )
}

export default CareersLP